import { jwtDecode } from 'jwt-decode';
import { Navigate, useLocation } from 'react-router-dom';
import { getAuthToken } from '@/src/lib/axios/auth-token';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const token = getAuthToken();

  // No token - redirect to sign in
  if (!token) {
    const redirectUrl = `/auth/signin?redirect=${encodeURIComponent(location.pathname + location.search)}`;
    return <Navigate to={redirectUrl} replace />;
  }

  try {
    // Decode and validate token
    const decodedToken = jwtDecode(token) as { exp?: number };

    // Check token expiration
    if (decodedToken.exp && Date.now() >= decodedToken.exp * 1000) {
      const redirectUrl = `/auth/signin?redirect=${encodeURIComponent(location.pathname + location.search)}`;
      return <Navigate to={redirectUrl} replace />;
    }
  } catch {
    // Token is malformed
    const redirectUrl = `/auth/signin?redirect=${encodeURIComponent(location.pathname + location.search)}`;
    return <Navigate to={redirectUrl} replace />;
  }

  return <>{children}</>;
}
